import { useEffect } from 'react';
import { useDocumentStore, useChatUIStore } from '@edgerunner/shared';

/**
 * Web-compatible search sync hook.
 *
 * In web mode, search is handled by the backend API (apiClient.search.query)
 * rather than local FlexSearch + IPC like in Electron.
 *
 * This hook simply logs when contexts are ready. The actual search
 * functionality is available through the SearchModal component which
 * uses the apiClient.search methods.
 */
export const useSearchSync = () => {
  const chatReady = useChatUIStore((s) => s.initialLoad);
  const docReady = useDocumentStore((s) => s.initialLoad);

  useEffect(() => {
    if (chatReady && docReady) {
      console.log('[useSearchSync] Web mode: contexts ready, search available via API');
    }
  }, [chatReady, docReady]);
};
